import React from "react";
// * Reducer
import { actions } from "./actions";
import { initialState } from "./constants";
import { reducer } from "./reducer";
// * Google maps
import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api";
// * Components
import { Search, Loader } from "components";
// * Styles
import { mapStyles } from "./mapStyles";
import "./styles.scss";
// * Libraries
const libraries = ["places"];
// * Map styles
const mapContainerStyle = {
  width: "100%",
  height: "450px",
};
// * Map options
const options = {
  styles: mapStyles,
  disableDefaultUI: true,
  zoomControl: true,
};
export const SelectLocation = (props) => {
  // * State
  const [state, dispatch] = React.useReducer(reducer, initialState);
  // * Load script
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: `${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`,
    libraries,
  });

  // * Change location handler
  const changeLocation = (lat, lng) => {
    dispatch({ type: actions.SET_LOCATION, payload: { lat, lng } });
    props.setMarker(lat, lng);
  };
  return (
    <div>
      {loadError ? (
        <div>Error al cargar el mapa</div>
      ) : !isLoaded ? (
        <div className="loader__container">
          <Loader />
        </div>
      ) : (
        <>
          <div className="search__container">
            <div className="search_input">
              <Search
                changeLocation={changeLocation}
                setLocation={props.setLocation}
              />
            </div>
          </div>
          <div className="map_container">
            <GoogleMap
              options={options}
              mapContainerStyle={mapContainerStyle}
              zoom={state.zoom}
              center={state.location}
            >
              <Marker
                key={props.markers.origin}
                position={props.markers.origin}
              />
              <Marker
                key={props.markers.destiny}
                position={props.markers.destiny}
              />
            </GoogleMap>
          </div>
        </>
      )}
    </div>
  );
};
